<template>
  <div>
    <dt>{{ label }}</dt>
    <dd v-html="options[value]" /> 
  </div>
</template>

<script>
export default {
  name: "view-c-protocolo-tipo-conta",
  props: {
    label: String,
    value: String,
  },
  data() {
    return {
      options: {
        ["Conta Corrente"]: "Conta Corrente",
        ["Conta Poupança"]: "Conta Poupança",
      },
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/View/TipoConta.vue